<template>
    <div class="orgCenter">
        <top/>
        <div class="teacherBox">
            <div class="content">
                <left/>
                <div class="middleLine"></div>
                <div class="right flex1">
                    <router-view />
                    <div class="right_fot">
                        <span class="left">© 2022青岛新闻网络传播有限公司</span>
                        <span class="right">公安部备案: 37020202000008 工信部备案:鲁B2-20051014</span>
                    </div>
                </div>
            </div>
           
        </div>
    </div>
</template>

<script>
import top from './top.vue'
import left from './left.vue'

export default {
    name: "Layout",
    components: {
        left: left,
        top: top
    }
}
</script>
<style scoped>
    .right_fot{
        text-align: center;margin-top: 100px;color: #707070;
        font-size: 14px;margin-left: 300px;
    }
    .left{
        margin-right: 100px;
    }
    .right{
    }
</style>